import React from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import AUIButton from '@ancert/aui-button';
import AUIDropdownButton from '@ancert/aui-dropdown-button';
import './ModalPDF.scss';

/**
 * Modal para mostrar el documento PDF con opciones de ayuda, validación y descarga
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @param {string} props.dataModal - URL del PDF a mostrar
 * @param {boolean|string} props.hasUnidos - Indica si hay documento unido disponible para descarga
 * @param {string} props.urlDescargaCopiaFirmada - URL para descargar la copia firmada
 * @param {function} props.onShowHelp - Función para mostrar ayuda
 * @param {function} props.onValidateSignature - Función para validar firma
 * @param {function} props.onDownloadDocument - Función para descargar documento unidos
 * @param {function} props.onDownloadSignedCopy - Función para descargar copia firmada
 * @param {boolean} props.validationLoading - Indica si la validación está en progreso
 * @returns {React.ReactElement} - Componente ModalPDF
 */
const ModalPDF = ({
  show,
  onClose,
  dataModal,
  hasUnidos,
  urlDescargaCopiaFirmada,
  onShowHelp,
  onValidateSignature,
  onDownloadDocument,
  onDownloadSignedCopy,
  validationLoading
}) => (
  <AUIModal
    show={show}
    className="modal-pdf-completa"
    onClose={onClose}
    title="Copia autorizada electrónica"
  >
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ flex: 1, minHeight: '0', overflow: 'auto', marginBottom: '1rem' }}>
        <iframe
          src={`${dataModal}#toolbar=1&navpanes=1&scrollbar=1`}
          title="pdfReader"
          height="100%"
          width="100%"
          style={{ border: '1px solid #e0e0e0', borderRadius: '4px', display: 'block' }}
        />
      </div>

      <div className="aui-modal__custom-footer" style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '1rem 0',
        flexShrink: 0,
        gap: '0.5rem'
      }}>
        <AUIButton
          mode="tertiary"
          label="Cerrar"
          onClick={onClose}
        />
        <div style={{ position: 'relative', zIndex: 9999 }}>
          <AUIDropdownButton
            label="Acciones"
            mode="primary"
            icon="moreVertical"
            iconPos="left"
            disabled={false}
            loading={false}
            appendTo={document.body}
            items={[
              {
                label: 'Ver ayuda',
                command: onShowHelp,
                disabled: false,
              },
              {
                label: 'Validar firma',
                command: onValidateSignature,
                disabled: validationLoading,
              },
              {
                label: 'Descargar',
                command: onDownloadSignedCopy,
                disabled: !urlDescargaCopiaFirmada,
              },
              ...(hasUnidos ? [{
                label: 'Descargar unidos',
                command: onDownloadDocument,
                disabled: false,
              }] : []),
            ]}
          />
        </div>
      </div>
    </div>
  </AUIModal>
);

ModalPDF.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  dataModal: PropTypes.string.isRequired,
  hasUnidos: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  urlDescargaCopiaFirmada: PropTypes.string,
  onShowHelp: PropTypes.func.isRequired,
  onValidateSignature: PropTypes.func.isRequired,
  onDownloadDocument: PropTypes.func.isRequired,
  onDownloadSignedCopy: PropTypes.func.isRequired,
  validationLoading: PropTypes.bool.isRequired,
};

ModalPDF.defaultProps = {
  urlDescargaCopiaFirmada: '',
};

export default ModalPDF;
